import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const withStructuredDataBreadcrumbs = WrappedComponent => (props) =>
{
    const location = useLocation();
    const segments = location.pathname.split('/').filter(segment => segment !== '');

    const formatLabel = (label) =>
    {
        const words = label.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1));
        return words.join(' ');
    };

    const breadcrumbs = [
        {
            path: '/',
            label: 'Home',
        },
        ...segments.map((segment, index) => ({
            path: `/${segments.slice(0, index + 1).join('/')}`,
            label: formatLabel(segment),
        })),
    ].filter((_, index) => index !== 2 && index !== 5);

    const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((breadcrumb, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: breadcrumb.label,
            item: window.location.origin + breadcrumb.path,
        })),
    };

    return (
        <>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            <WrappedComponent {...props} breadcrumbs={breadcrumbs} />
        </>
    );
};

export default withStructuredDataBreadcrumbs;
